import React from "react";

const ContactUsModule = React.lazy(() => import("./ui/ContactUs"));

export const ContactUsPage = () => {
  return <ContactUsModule />;
};
